module.exports = __webpack_public_path__ + "static/media/20.8f8f8527.JPG";